export default __webpack_public_path__ + "static/media/logo.5ba3cc40.png";